import { useEffect, useState } from 'react';
import { useStyles } from './EditUserDatePicker.styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTextField } from '../EditSession/TaskGroupDetails.styles';
import plLocale from 'date-fns/locale/pl';
import React from 'react';
import { DateValidationError } from '@mui/x-date-pickers/internals/hooks/validation/useDateValidation';

interface ExaminerCalendarPickerProps {
  dateArg: Date | null;
  dateToParent: (_date: Date | null) => void;
  disablePast?: boolean;
  isDateValid: (value:boolean) => void;

}

const ExaminerCalendarPicker = (props: ExaminerCalendarPickerProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(props.dateArg);
  const [error, setError] = React.useState<DateValidationError | null>(null);

  const errorMessage = React.useMemo(() => {
    switch (error) {
      case 'invalidDate': {
        props.isDateValid(true);
        return 'Nieprawidłowy format daty';
      }

      default: {
        props.isDateValid(false);
        return '';
      }
    }
  }, [error]);

  const classes = useStyles();

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    props.dateToParent(date);
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={plLocale}>
        <DatePicker
          label="Data ważności konta"
          aria-label="data ważności konta"
          views={['year', 'month', 'day']}
          inputFormat="dd/MM/yyyy"
          onChange={handleDateChange}
          value={selectedDate}
          disablePast={props.disablePast}
          renderInput={(params) => (
            <DateTextField
              {...params}
              style={{ width: '320px' }}
              helperText={errorMessage}
            />
          )}
          onError={setError}
        />
      </LocalizationProvider>
    </>
  );
};

export default ExaminerCalendarPicker;
